var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImport(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 68.357,
    height: 44.108,
    viewBox: "0 0 68.357 44.108",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12484",
    "data-name": "Group 12484",
    transform: "translate(-1348.857 108.322)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_1075",
    "data-name": "Line 1075",
    x1: 4.543,
    y1: 1.569,
    transform: "translate(1355.403 -83.266)",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1076",
    "data-name": "Line 1076",
    x1: 4.543,
    y1: 1.569,
    transform: "translate(1396.041 -87.098)",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1077",
    "data-name": "Line 1077",
    x1: 4.543,
    y1: 1.569,
    transform: "translate(1407.159 -77.897)",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1078",
    "data-name": "Line 1078",
    x1: 4.543,
    y1: 1.569,
    transform: "translate(1358.538 -76.822)",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1079",
    "data-name": "Line 1079",
    x1: 4.543,
    y1: 1.569,
    transform: "translate(1383.037 -70.146)",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1080",
    "data-name": "Line 1080",
    x1: 8.734,
    y1: 3.017,
    transform: "translate(1389.424 -67.94)",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1081",
    "data-name": "Line 1081",
    x1: 4.543,
    y1: 1.569,
    transform: "translate(1356.665 -107.613)",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1082",
    "data-name": "Line 1082",
    x1: 8.734,
    y1: 3.017,
    transform: "translate(1363.052 -105.407)",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1083",
    "data-name": "Line 1083",
    x1: 25.344,
    y1: 8.755,
    transform: "translate(1390.146 -96.048)",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40583",
    "data-name": "Path 40583",
    d: "M1440.216,263.366l2.784,5.723-5.405,2.63",
    transform: "translate(-26.788 -356)",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40584",
    "data-name": "Path 40584",
    d: "M1409.944,278.5l16.6,5.524c7.442,2.476,9.155-4.584-1.626-8.487-5.882-2.13-23.5-7.946-34.9-11.682,0,0-3.115-10.187-4.48-10.641l-2.431-.809-1.6,10.276-4.4,3.939,2.431.809,9.208-1.657",
    transform: "translate(-26.788 -356)",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40585",
    "data-name": "Path 40585",
    d: "M1401.358,275.642l-5.724-1.9c-2.642-.879-6.8-3.428-10.877-7.434",
    transform: "translate(-26.788 -356)",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1084",
    "data-name": "Line 1084",
    x1: 4.007,
    y1: 1.333,
    transform: "translate(1401.279 -76.556)",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40586",
    "data-name": "Path 40586",
    d: "M1413.565,271.439s-7.636-9.534-8.78-9.915l-3.929-1.308,1.834,7.6",
    transform: "translate(-26.788 -356)",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40587",
    "data-name": "Path 40587",
    d: "M1413.241,277.689s-13.3,3.2-14.878,2.678L1394,278.915l9.649-4.419",
    transform: "translate(-26.788 -356)",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImport);
export default __webpack_public_path__ + "static/media/import.1277217c31f978b0a6e62e3652979c0d.svg";
export { ForwardRef as ReactComponent };